/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RoutinesResponse } from '../../models/routines-response';

export interface RunRoutine$Params {
  routine_id: string;
}

export function runRoutine(http: HttpClient, rootUrl: string, params: RunRoutine$Params, context?: HttpContext): Observable<StrictHttpResponse<RoutinesResponse>> {
  const rb = new RequestBuilder(rootUrl, runRoutine.PATH, 'put');
  if (params) {
    rb.path('routine_id', params.routine_id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RoutinesResponse>;
    })
  );
}

runRoutine.PATH = '/routines/{routine_id}/run';
